// NEW CODE
import React, { useState, useEffect, useRef } from 'react';
import { Clock } from 'lucide-react';

const RecentSearches = ({ onSelectQuery, isVisible, setIsVisible, recentSearches, highlightedIndex, onKeyDown, isLoading = false }) => {
  const listRef = useRef(null);

  useEffect(() => {
    if (highlightedIndex !== -1 && listRef.current) {
      const highlightedElement = listRef.current.children[highlightedIndex];
      if (highlightedElement) {
        highlightedElement.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }, [highlightedIndex]);

  const getTimeAgo = (timestamp) => {
    if (!timestamp) return 'Unknown time';

    // Handle Firestore Timestamp format
    let searchTime;
    if (timestamp._seconds !== undefined) {
      // If it's a Firestore timestamp
      searchTime = new Date(timestamp._seconds * 1000);
    } else if (timestamp.seconds !== undefined) {
      // Alternative Firestore timestamp format
      searchTime = new Date(timestamp.seconds * 1000);
    } else {
      // Regular date string/timestamp
      searchTime = new Date(timestamp);
    }
    
    if (isNaN(searchTime.getTime())) {
      return 'Invalid date';
    }

    const now = new Date();
    const diffInMinutes = Math.floor((now - searchTime) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  if (!isVisible) return null;

  // Show loading state
  if (isLoading) {
    return (
      <div className="absolute z-50 w-full mt-1 bg-gray-800 border border-secondary rounded-md shadow-lg focus-within:ring-2 focus-within:ring-secondary">
        <div className="px-4 py-2 text-sm text-gray-400 border-b border-gray-600">
          Recent Questions
        </div>
        <div className="py-4 flex items-center justify-center">
          <div className="animate-spin mr-2 text-secondary">
            <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
          <span className="text-gray-300">Loading recent searches...</span>
        </div>
      </div>
    );
  }
  
  // Show empty state
  if (recentSearches.length === 0) {
    return (
      <div className="absolute z-50 w-full mt-1 bg-gray-800 border border-secondary rounded-md shadow-lg focus-within:ring-2 focus-within:ring-secondary">
        <div className="px-4 py-2 text-sm text-gray-400 border-b border-gray-600">
          Recent Questions
        </div>
        <div className="py-4 text-center text-gray-400">
          No recent searches found
        </div>
      </div>
    );
  }

  return (
    <div className="absolute z-50 w-full mt-1 bg-gray-800 border border-secondary rounded-md shadow-lg focus-within:ring-2 focus-within:ring-secondary">
      <div className="px-4 py-2 text-sm text-gray-400 border-b border-gray-600">
        Recent Questions
      </div>
      <ul ref={listRef} className="py-1 overflow-y-auto" style={{ maxHeight: '260px' }}>
        {recentSearches.map((search, index) => (
          <li
            key={search.id}
            className={`group px-4 py-2 hover:bg-gray-900 cursor-pointer text-white transition-all duration-200 ease-in-out rounded-md border border-transparent focus:ring-2 focus:ring-secondary ${
              index === highlightedIndex ? 'bg-gray-900' : ''
            }`}
            onClick={() => onSelectQuery(search)}
          >
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className="truncate">{search.userQuery}</p>
                <div className="flex items-center mt-1 text-xs text-gray-400">
                  <Clock size={12} className="mr-1" />
                  {getTimeAgo(search.timestamp)}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecentSearches;